import { Subject } from 'rxjs';

const httpCancelation$ = new Subject();

export const httpCancel = () => {
  httpCancelation$.next(1);
};

export default httpCancelation$;
